import { Attachment } from '../types/blueprint'

import { DisplayInfoWrapper, SmallHeading } from './DisplayBlock.style'

import { AttachmentBoxes } from '@/components/shared-components/AttachmentBox'

export const SIZE = 88
export const PDF_SIZE = 150

type Props = {
  attachments: Attachment[] | false
  renderingInPdf?: boolean
  title?: string
}

/**
 * Used directly when rendering the template in "display" mode
 */
export const DisplayAttachments: React.FC<Props> = ({
  attachments = [],
  renderingInPdf,
  title = 'Attachments',
}) => {
  if (!attachments || !attachments?.length) return null

  return (
    <DisplayInfoWrapper>
      {title?.length ? <SmallHeading>{title}</SmallHeading> : null}

      <AttachmentBoxes
        attachments={attachments?.map((a, i) => ({
          alt: a.name ?? 'Attachment ' + (i + 1),
          url: a.thumbnailUrl ?? a.url,
          previewUrl: a.url,
        }))}
        width={renderingInPdf ? PDF_SIZE : SIZE}
        height={renderingInPdf ? PDF_SIZE : SIZE}
        renderingInPdf={renderingInPdf}
      />
    </DisplayInfoWrapper>
  )
}
